<template>
  <b-overlay :show="show" rounded="md" :shown="shown()">
    <b-container id="main-container" fluid style>
      <b-row style="width: 100%; background-color: #e8e8ea" align-h="center">
        <b-col class="" cols="12">
          <nav-header ref="header"></nav-header>
        </b-col>
      </b-row>

      <b-row
        align-h="center"
        style="width: 100%; margin-top: 60px; background-color: #ffedc3"
      >
        <b-col
          cols="12"
          style="padding-top: 5px"
          class="pl-0 pr-0 cart-nav-bundle"
        >
          <b-row style="">
            <b-col
              class="pl-pr-0-sm pb-0"
              cols="12"
              style="
                background-color: #ffedc3;
                padding-left: 5%;
                padding-right: 5%;
              "
            >
              <b-row class="pt-4" data-aos="fade-right" data-aos-delay="250">
                <b-col
                  class="hero-text-sm"
                  style="
                    color: #feb60d;
                    font-weight: 700;
                    max-width: 1080px;
                    margin: 0 auto;
                  "
                >
                  Truthbrush Kiosk
                </b-col>
              </b-row>
              <b-row class="pt-2">
                <b-col
                  style="
                    font-size: 16px;
                    color: #45484b;
                    max-width: 1080px;
                    margin: 0 auto;
                  "
                >
                  Select your bundle and checkout. Then pick up your Truthbrush from Kiosk.
                </b-col>
              </b-row>

              <b-row class="pb-1 pl-3 pr-3">
                <b-col
                  cols="12"
                  class="pt-4 pb-4 pl-0 pr-0"
                  v-for="(item, index) in inventory_pro"
                  :key="index"
                  style="max-width: 1080px; margin: 0 auto"
                >
                  <b-row>
                    <b-col
                      style="background-color: white; border-radius: 10px"
                      class="pl-1 pr-1"
                    >
                      <b-row class="pt-4">
                        <b-col
                          class="bundle-h1 align-center-small"
                          v-if="index == 0"
                        >
                          <span style="color: #2f95eb">Pro Tracker Bundle</span>
                        </b-col>
                        <b-col
                          class="bundle-h1 align-center-small"
                          v-if="index == 1"
                        >
                          <span style="color: #2f95eb"
                            >New Classic Tracker</span
                          >
                          + <span style="color: #00bea4">Hub</span> Bundle
                        </b-col>
                        <b-col
                          class="bundle-h1 align-center-small"
                          v-if="index == 2"
                        >
                          <span style="color: #2f95eb">Skin </span> Collection
                        </b-col>
                        <b-col
                          class="bundle-h1 align-center-small"
                          v-if="index == 3"
                        >
                          <span style="color: #2f95eb"
                            >New Classic Tracker</span
                          >
                          + <span style="color: #00bea4">Hub</span> Bundle
                        </b-col>
                      </b-row>
                      <b-row>
                        <b-col
                          class="pt-2 pb-3 align-center-small"
                          style="font-size: 12px"
                        >
                          Includes {{ getH3(item, 0) }} and
                          {{ getH3(item, 2) }}. {{ getH4(item) }}
                        </b-col>
                      </b-row>
                      <b-row>
                        <b-col
                          md="6"
                          cols="12"
                          class="pl-pr-0-sm pt-0 hide-when-big"
                        >
                          <b-row class="pt-2 pb-4">
                            <b-col>
                              <VueSlickCarousel ref="carouselkiosk"
                                :arrows="false"
                                :dots="true"
                                :slidesToShow="1"
                                :swipeToSlide="true"
                                :touchThreshold="20"
                                :centerMode="true"
                                :centerPadding="'0%'"
                                :responsive="[
                                  {
                                    breakpoint: 400,
                                    settings: {
                                      slidesToShow: 1,
                                    },
                                  },
                                  {
                                    breakpoint: 700,
                                    settings: {
                                      slidesToShow: 1,
                                    },
                                  },
                                  {
                                    breakpoint: 1080,
                                    settings: {
                                      slidesToShow: 2,
                                    },
                                  },
                                ]"
                              >
                                <div
                                  class="abaserd"
                                  style="background-color: #555532"
                                >
                                  <b-img
                                    :src="getImage2(item)"
                                    center
                                    fluid
                                  ></b-img>
                                </div>
                                <div style="background-color: blue">
                                  <b-img
                                    src="/img/products/pro_2.jpg"
                                    center
                                    fluid
                                  ></b-img>
                                </div>
                                <div>
                                  <b-img
                                    src="/img/products/pro_3.jpg"
                                    center
                                    fluid
                                  ></b-img>
                                </div>
                                <div>
                                  <b-img
                                    src="/img/products/pro_4.jpg"
                                    center
                                    fluid
                                  ></b-img>
                                </div>
                                <div>
                                  <b-img
                                    src="/img/products/pro_5.jpg"
                                    center
                                    fluid
                                  ></b-img>
                                </div>
                                <div>
                                  <b-img
                                    src="/img/products/pro_6.jpg"
                                    center
                                    fluid
                                  ></b-img>
                                </div>
                                
                              </VueSlickCarousel>
                            </b-col>
                          </b-row>
                        </b-col>
                      </b-row>
                      <b-row class="pt-2 pb-5">
                        <b-col md="6" cols="12" class="hide-when-small">
                          <b-row>
                            <b-col>
                              <b-img
                                center
                                class="image_bundle"
                                fluid
                                :src="getImage2(item)"
                              ></b-img>
                            </b-col>
                          </b-row>
                          <b-row class="pb-2">
                            <b-col
                              style="
                                color: #323436;
                                font-size: 21px;
                                text-align: center;
                              "
                            >
                              What's in the Bundle?
                            </b-col>
                          </b-row>
                          <b-row>
                            <b-col
                              style="
                                color: #323436;
                                font-size: 17px;
                                text-align: center;
                              "
                            >
                              {{ getH3(item, 0) }}
                            </b-col>
                          </b-row>
                          <b-row>
                            <b-col
                              style="
                                color: #323436;
                                font-size: 17px;
                                text-align: center;
                              "
                            >
                              {{ getH3(item, 1) }}
                            </b-col>
                          </b-row>
                          <b-row>
                            <b-col
                              style="
                                color: #323436;
                                font-size: 17px;
                                text-align: center;
                              "
                            >
                              {{ getH3(item, 2) }}
                            </b-col>
                          </b-row>
                          <b-row class="pt-2">
                            <b-col
                              cols="8"
                              style="
                                color: #323436;
                                font-size: 12px;
                                text-align: center;
                                margin: 0 auto;
                              "
                            >
                              {{ getH4(item) }}
                            </b-col>
                          </b-row>
                        </b-col>

                        <b-col md="6" cols="12" class="pl-1 pr-1">
                          <b-row v-if="item.list.length > 1" class="pt-2">
                            <b-col
                              cols="12"
                              style="display: contents"
                              class="bundle-h2"
                            >
                              <span style="color: #323436">
                                Select number of
                              </span>
                              <span
                                style="color: #2f95eb; padding-left: 7px"
                                v-if="index == 0"
                              >
                                Trackers
                              </span>
                              <span
                                style="color: #2f95eb; padding-left: 7px"
                                v-if="index == 1"
                              >
                                Classic Trackers
                              </span>
                            </b-col>
                          </b-row>
                          <b-row v-if="item.list.length > 1">
                            <b-col
                              style=""
                              class="pt-2 bundle-cell"
                              v-for="(item2, index2) in item.list"
                              :key="index2"
                            >
                              <b-img
                                fluid
                                center
                                :src="item2.tracker_size_img"
                                style="cursor: pointer"
                                :class="{
                                  'selected-border': index2 == item.index1,
                                }"
                                class="unselected-border"
                                @click="select_bundle_size(item, index2)"
                              ></b-img>
                            </b-col>
                          </b-row>

                          <b-row
                            class="pt-3"
                            v-if="
                              item.list[item.index1].skus[item.index2].opt
                                .length >= 1
                            "
                          >
                            <b-col
                              cols="12"
                              style="display: contents"
                              class="bundle-h2"
                            >
                              <span style="color: #323436"> Select </span>
                              <span style="color: #00bea4" class="pl-2 pr-2"
                                >Hub</span
                              >
                              <span style="color: #323436" class="pr-2">
                                options
                              </span>
                            </b-col>
                          </b-row>
                          <b-row
                            v-if="
                              item.list[item.index1].skus[item.index2].opt
                                .length >= 1
                            "
                          >
                            <b-col
                              style=""
                              class="pt-2 bundle-cell"
                              v-for="(item2, index2) in hub_type"
                              :key="index2"
                            >
                              <b-img
                                fluid
                                center
                                :src="item2.image"
                                style="cursor: pointer"
                                class="unselected-border"
                                :class="{
                                  'selected-border': index2 == item.index3,
                                }"
                                @click="select_bundle_hub(item, index2)"
                              ></b-img>
                            </b-col>
                          </b-row>

                          <b-row class="pt-2">
                            <hr style="width: 100%; height: 1px" />
                          </b-row>
                          <b-row
                            v-if="
                              getCoupon() == 'babysideburns' ||
                              getCoupon() == 'A3KzVdj8'
                            "
                            class="pb-2"
                          >
                            <b-col
                              class="pl-0 pt-1 pb-1"
                              style="
                                color: white;
                                background-color: #d9735c;
                                text-align: center;
                              "
                            >
                              Baby Sideburns Sale!
                            </b-col>
                          </b-row>

                          <b-row
                            v-if="getCoupon() == '5minutesformom'"
                            class="pb-2"
                          >
                            <b-col
                              class="pl-0 pt-1 pb-1"
                              style="
                                color: white;
                                background-color: #d9735c;
                                text-align: center;
                              "
                            >
                              5 Minutes for Mom Special Price!
                            </b-col>
                          </b-row>
                          <b-row v-if="getCoupon() == 'pin10'" class="pb-2">
                            <b-col
                              class="pl-0 pt-1 pb-1"
                              style="
                                color: white;
                                background-color: #d9735c;
                                text-align: center;
                              "
                            >
                              Memorial Day Sale.
                            </b-col>
                          </b-row>
                          <b-row v-if="calculateFinalPrice(100) == 100">
                            <b-col
                              style="color: #1f2122; font-size: 27px"
                              class="align-center-small pl-0 pr-0"
                            >
                              ${{ getPrice(index, 1) }} (${{
                                getPrice(index, 0)
                              }}
                              value)
                            </b-col>
                          </b-row>

                          <b-row v-else>
                            <b-col
                              style="color: #1f2122; font-size: 25px"
                              class="align-center-small pl-0 pr-0"
                            >
                              ${{ calculateFinalPrice(getPrice(index, 1)) }}

                              <strike>${{ getPrice(index, 0) }}</strike>
                              ({{
                                (
                                  (1 -
                                    calculateFinalPrice(getPrice(index, 1)) /
                                      getPrice(index, 0)) *
                                  100
                                ).toFixed(0)
                              }}% Off)
                            </b-col>
                          </b-row>

                          <b-row class="pt-2 pb-1 pl-0 reduced_pl_pr">
                            <b-col
                              style="background-color: #e7f8fd"
                              class="pt-3 pb-3 pr-0"
                            >
                              <b-row>
                                <b-col
                                  cols="2"
                                  class="reduced_pl_pr pl-0 pr-1"
                                  align-self="center"
                                >
                                  <b-img
                                    src="img/tb-ic-paypal@2x.png"
                                    style="max-width: 35px"
                                    fluid
                                  ></b-img>
                                </b-col>
                                <b-col cols="10" class="pl-0 pr-0">
                                  <b-row
                                    style="justify-content: left"
                                    class="pt-1"
                                  >
                                    <b-col cols="pl-0 pr-0">
                                      <b style="font-size: 14px">
                                        Buy Now, Pay Later with PaylPal</b
                                      >
                                    </b-col>
                                  </b-row>
                                  <b-row
                                    style="justify-content: left"
                                    class="pt-0"
                                  >
                                    <b-col cols="pl-0 pr-0">
                                      <b
                                        style="font-size: 14px; color: #c84141"
                                        v-if="calculateFinalPrice(100) == 100"
                                        >4 interest-free payments of ${{
                                          (getPrice(index, 1) / 4.0).toFixed(2)
                                        }}</b
                                      >
                                      <b
                                        style="font-size: 14px; color: #c84141"
                                        v-else
                                        >4 interest-free payments of ${{
                                          (
                                            calculateFinalPrice(
                                              getPrice(index, 1)
                                            ) / 4.0
                                          ).toFixed(2)
                                        }}</b
                                      >
                                      <b class="hide-when-small">
                                        with Pay in 4</b
                                      >
                                    </b-col>
                                  </b-row>
                                </b-col>
                              </b-row>
                            </b-col>
                          </b-row>

                          <b-row>
                            <b-col cols="12" class="pl-0 pr-0 pt-3">
                              <b-button
                                pill
                                class="blue-button max-width-sm"
                                style="width: 200px; height: 40px"
                                v-on:click="
                                  onAddCart2(
                                    item,
                                    item.index1,
                                    item.index2,
                                    item.index3
                                  )
                                "
                              >
                                <span style="font-size: 18px">Checkout</span>
                              </b-button>
                            </b-col>
                          </b-row>

                          <b-row class="pt-3 hide-when-small" hidden>
                            <b-col
                              style="color: #323436; font-size: 14px"
                              class="pl-0 pr-0"
                              v-if="index == 2"
                            >
                              Free US Shipping ($50 or above) | Ship Worldwide
                            </b-col>
                            <b-col
                              style="color: #323436; font-size: 14px"
                              class="pl-0 pr-0"
                              v-else
                            >
                              Free US Shipping | Ship Worldwide
                            </b-col>
                          </b-row>
                          <b-row class="pt-3 hide-when-small">
                            <b-col
                              style="color: #323436; font-size: 14px"
                              class="pl-0 pr-0"
                            >
                              Factory Warranty | 30 Day Guarantee
                            </b-col>
                          </b-row>
                        </b-col>
                      </b-row>
                    </b-col>
                  </b-row>
                </b-col>
              </b-row>
            </b-col>
          </b-row>
        </b-col>




        
      </b-row>
      <b-row class='pt-4 main-jumbotron'>
        <b-col cols='12'>
          <b-row
            style="width: 100%; position: relative; padding-bottom: 60px"
            align-h="center"
            class="main-jumbotron reduced-pb-0 pt-0"
          >
            <b-col cols="12" class="pl-0 pr-0">
              <b-row class="mt-3 mb-5">
                <b-col cols="12" class="pl-0 pr-0">
                  <b-row class="justify-content-center pt-3">
                    <h1 style="max-width: 100%" class="h1-font">
                      The Truthbrush Pro
                    </h1>
                  </b-row>
                  <b-row
                    class="
                      justify-content-center
                      align-center
                      pt-2
                      pl-3
                      pr-3
                      h4-font
                    "
                    style="
                      max-width: 700px;
                      margin: auto !important;
                      font-size: 14px;
                    "
                  >
                    State of the art design and engineering - the all new
                    Truthbrush Pro tracker packs our most powerful processor and
                    oral care sensing technology with multi year functionality,
                    louder beep timer & longer wireless range, all into a small,
                    sleek and modern design. Works with any toothbrush; manual
                    or electric; any brand. Pairs with the Truthbrush app to set
                    goals, get feedback, earn rewards and share with your
                    dentist.
                  </b-row>
                  <b-row class="pt-5">
                    <b-col class="pr-5 pl-5 reduced_pl_pr">
                      <b-img
                        src="/img/hero-pro-min.png"
                        style="max-height: 650px"
                        center
                        fluid
                      ></b-img>
                    </b-col>
                  </b-row>
                </b-col>
              </b-row>

              
              
            </b-col>
          </b-row>

          <b-row class="pt-0">
            <b-col class="pl-0 pr-0 hide-when-small">
              <b-img-lazy fluid src="img/Frame-31-min.jpg"></b-img-lazy>
            </b-col>
            <b-col class="pl-0 pr-0 hide-when-big">
              <b-img-lazy fluid src="img/Frame-31-min1.jpg"></b-img-lazy>
            </b-col>
          </b-row>
          <b-row class="pt-5">
            <b-col class="pl-0 pr-0 hide-when-small">
              <b-img-lazy fluid src="img/Frame-26-min.jpg"></b-img-lazy>
            </b-col>
            <b-col class="pl-0 pr-0 hide-when-big">
              <b-img-lazy fluid src="img/Frame-26-min1.jpg"></b-img-lazy>
            </b-col>
          </b-row>
          <b-row class="pt-5">
            <b-col class="pl-0 pr-0 hide-when-small">
              <b-img-lazy fluid src="img/Frame-27-min.jpg"></b-img-lazy>
            </b-col>
            <b-col class="pl-0 pr-0 hide-when-big">
              <b-img-lazy fluid src="img/Frame-27-min1.jpg"></b-img-lazy>
            </b-col>
          </b-row>
          <b-row class="pt-5">
            <b-col class="pl-0 pr-0 hide-when-small">
              <b-img-lazy fluid src="img/Frame-28-min.jpg"></b-img-lazy>
            </b-col>
            <b-col class="pl-0 pr-0 hide-when-big">
              <b-img-lazy fluid src="img/Frame-28-min1.jpg"></b-img-lazy>
            </b-col>
          </b-row>
          <b-row class="pt-5">
            <b-col class="pl-0 pr-0 hide-when-small">
              <b-img-lazy fluid src="img/Frame-32-min.jpg"></b-img-lazy>
            </b-col>
            <b-col class="pl-0 pr-0 hide-when-big">
              <b-img-lazy fluid src="img/Frame-32-min1.jpg"></b-img-lazy>
            </b-col>
          </b-row>

          <b-row class="pt-5">
            <b-col class="pl-0 pr-0">
              <b-row class="justify-content-center pt-3">
                <h1 style="max-width: 100%" class="h1-font">
                  Packaging Content
                </h1>
              </b-row>
              <b-row
                class="
                  justify-content-center
                  align-center
                  pt-2
                  pl-3
                  pr-3
                  h4-font
                "
                style="
                  max-width: 700px;
                  margin: auto !important;
                  font-size: 18px;
                "
              >
                The Truthbrush consists of Tracker and Hub, both are required
                for the system to work. Each Hub can support multiple Trackers
                at the same time. Additional Hub can be added for expanded
                coverage area. If you have never purchased Truthbrush before,
                please select one of the bundles. If you already have a Hub and
                would like to purchase additional Tracker or Tracker Pro, please
                select the Tracker Pro only option. Image for illustration only,
                actual packaging and content varies based on actual order.
              </b-row>
              <b-row class="pt-5">
                <b-col class="pr-5 pl-5 reduced_pl_pr">
                  <b-img
                    src="/img/hero2-min.png"
                    style="max-height: 650px"
                    center
                    fluid
                  ></b-img>
                </b-col>
              </b-row>
            </b-col>
          </b-row>

          <b-row class="pt-5">
            <b-col class="pl-0 pr-0">
              <b-row class="justify-content-center pt-3">
                <h1 style="max-width: 100%" class="h1-font">
                  Technical Specification
                </h1>
              </b-row>
              <b-row
                class="
                  justify-content-center
                  align-center
                  pt-2
                  pl-3
                  pr-3
                  h4-font
                "
                style="
                  max-width: 700px;
                  margin: auto !important;
                  font-size: 18px;
                "
              >
                Truthbrush Pro Tracker+Hub
              </b-row>

              <b-row class="pt-5">
                <b-col cols="6" md="6" class="pb-5 reduced_pl_pr">
                  <b-row>
                    <b-col class="reduced_pl_pr">
                      <b-img
                        src="/img/Group-206.jpg"
                        center
                        style="max-height: 360px; max-width: 100%"
                        class="image-side-2-side"
                      ></b-img>
                    </b-col>
                  </b-row>
                  <b-row
                    style="
                      justify-content: center;
                      font-size: 22px;
                      padding-top: 20px;
                    "
                    class="h4-font"
                  >
                    Tracker Pro
                  </b-row>
                </b-col>
                <b-col cols="6" md="6" class="reduced_pl_pr">
                  <b-row>
                    <b-col class="reduced_pl_pr">
                      <b-img
                        src="/img/diagram-hub-en.png"
                        center
                        style="max-height: 360px; max-width: 100%"
                        class="image-side-2-side"
                      ></b-img>
                    </b-col>
                  </b-row>
                  <b-row
                    style="
                      justify-content: center;
                      font-size: 22px;
                      padding-top: 20px;
                    "
                    class="h4-font"
                  >
                    Truthbrush Hub
                  </b-row>
                </b-col>
              </b-row>

              <b-row class="pt-0 pl-5 pr-5 reduced_pl_pr">
                <b-col cols="12">
                  <hr
                    style="
                      width: 100%;
                      border: 0.5px solid #d9dadb;
                      margin-left: 0;
                    "
                  />
                </b-col>
              </b-row>

              <b-row class="pt-3 spec">
                <b-col cols="6" class="pl-pr-0-sm">
                  <b-row>
                    <b-col cols="12">
                      <b>Dimension/Weight</b>
                    </b-col>
                    <b-col cols="12"> 0.9*0.29 inch, 0.2 Ounce </b-col>
                  </b-row>
                  <b-row class="pt-3">
                    <b-col cols="12">
                      <b>Attachment</b>
                    </b-col>
                    <b-col cols="12"> Elastic stripe (Fit all) </b-col>
                  </b-row>
                  <b-row class="pt-3">
                    <b-col cols="12">
                      <b>Wireless communication</b>
                    </b-col>
                    <b-col cols="12"> Bluetooth LE </b-col>
                  </b-row>
                  <b-row class="pt-3">
                    <b-col cols="12">
                      <b>Water resistance</b>
                    </b-col>
                    <b-col cols="12"> Submerge </b-col>
                  </b-row>
                  <b-row class="pt-3">
                    <b-col cols="12">
                      <b>Battery</b>
                    </b-col>
                    <b-col cols="12">
                      Replaceable (CR1620), up to 9 months
                    </b-col>
                  </b-row>
                </b-col>

                <b-col cols="6" class="pl-pr-0-sm">
                  <b-row>
                    <b-col cols="12">
                      <b>Voltage</b>
                    </b-col>
                    <b-col cols="12"> 110-240v </b-col>
                  </b-row>
                  <b-row class="pt-3">
                    <b-col cols="12">
                      <b>Plug type</b>
                    </b-col>
                    <b-col cols="12"> US Type-A </b-col>
                  </b-row>
                  <b-row class="pt-3">
                    <b-col cols="12">
                      <b>Working distance</b>
                    </b-col>
                    <b-col cols="12"> 50 feet </b-col>
                  </b-row>
                  <b-row class="pt-3">
                    <b-col cols="12">
                      <b>Multiple tracker support</b>
                    </b-col>
                    <b-col cols="12"> Yes </b-col>
                  </b-row>
                  <b-row class="pt-3">
                    <b-col cols="12">
                      <b>Wireless protocol</b>
                    </b-col>
                    <b-col cols="12"> WiFi 2.4GHz </b-col>
                  </b-row>
                </b-col>
              </b-row>
              <b-row style="justify-content: center" class="pt-5">
                <a href="/#/product">Additional information</a>
              </b-row>
              <b-row class="pt-3 pl-5 pr-5 reduced_pl_pr">
                <b-col cols="12">
                  <hr
                    style="
                      width: 100%;
                      border: 0.5px solid #d9dadb;
                      margin-left: 0;
                    "
                  />
                </b-col>
              </b-row>

              <b-row class="justify-content-center pt-3">
                <h1 style="max-width: 100%; text-align: center" class="h1-font">
                  Frequently Asked Questions
                </h1>
              </b-row>
              <b-row class="pl-5 pr-5 reduced_pl_pr">
                <VueFaqAccordion
                  :items="myItems"
                  :activeColor="activeColorAccordian"
                  :borderColor="borderColorAccordian"
                />
              </b-row>
              <b-row style="justify-content: center" class="pt-5 pb-5">
                <a href="/#/faq">Visit our FAQ section</a>
              </b-row>
            </b-col>
          </b-row>
        </b-col>
      </b-row>

      <b-row style="width: 100%">
        <nav-footer></nav-footer>
      </b-row>

      <b-row>
        <Checkout-Express id="my-modal" ref="my-modal"> </Checkout-Express>
      </b-row>
    </b-container>
  </b-overlay>
</template>

<script>
import NavHeader from "./../components/NavHeader";
import NavFooter from "./../components/NavFooter";
import CheckoutExpress from "./../components/CheckoutExpress";
import VueSlickCarousel from "vue-slick-carousel";
import "vue-slick-carousel/dist/vue-slick-carousel.css";
import "vue-slick-carousel/dist/vue-slick-carousel-theme.css";
import VueFaqAccordion from "vue-faq-accordion";
import storage from "../storage";
import store from "../store";
import env from "../env";
export default {
  name: "Bundle",
  components: {
    NavHeader,
    NavFooter,
    CheckoutExpress,
    VueSlickCarousel,
    VueFaqAccordion
  },
  data() {
    return {
      show: false,
      activeColorAccordian: "#000000",
      borderColorAccordian: "#d9dadb",
      myItems: [
        {
          title: "1. What is a Truthbrush tracker?",
          value:
            "The Truthbrush tracker is a small, decorative device that fits on any manual or electric toothbrush. The tracker records motion activity when the toothbrush is used. This activity is displayed in the Truthbrush mobile application. It displays daily activity like a fitness tracker and includes time of day, brush duration, mouth coverage, and movement analysis. The tracker also has a configurable beep timer to help build proper habits.",
        },
        {
          title: "2. What is the Truthbrush hub?",
          value:
            "The Truthbrush hub is a unit that plugs into any wall outlet. The hub connects to the local Wi-Fi and routes data from all Truthbrush trackers within a 30 ft. range to the Truthbrush service. The hub collects data passively in the background.",
        },
        {
          title:
            "3. Is there a monthly fee after purchasing the tracker and hub?",
          value: "No.",
        },
        {
          title:
            "4. Do I need a separate Hub if I own both the Truthbrush Pro and the Truthbrush tracker?",
          value:
            "No. The Hub is compatible with both the Truthbrush tracker and the Truthbrush Pro.",
        },
        {
          title: "5. Do I need more than one hub?",
          value:
            "The hub is designed to accommodate multiple Truthbrush trackers. The hub will collect data from all trackers within 30 ft. Multiple hubs can be used in large homes where the bathrooms might be spread out.",
        },
        {
          title: "6. Does my phone need to be in the bathroom when I brush?",
          value:
            "No, Truthbrush is specifically designed to avoid bringing a phone into the bathroom or the need to open an any app. Your phone can be turned off and it will not impact the ability for Truthbrush to collect data. Parents do not want their kids looking at the phone in the bathroom and the data can never be reliably collected when the phone is required.",
        },
        {
          title: "7. Do I need to start the tracker when I brush?",
          value:
            "No, Truthbrush is designed so that you simply pick up the toothbrush and brush as you normally do, there are no stop or start buttons! The tracker will wake up on its own when you list the toothbrush and start recording. Truthbrush can tell the difference between toothbrushing activity and simply applying toothpaste or cleaning. The resulting data will reflect actual brush activity.",
        },

        {
          title: "8. Do I need to stop the tracker after brushing is complete?",
          value:
            "No, Truthbrush will detect that motion is idle and will then upload brushing data to server and go to sleep mode.",
        },
      ],
      hub_type: [
        {
          image: "/img/products/travel_hub.png",
        },
      ],
      inventory_pro: [
        {
          h1: "Includes the new (2023 model year) Pro Trackers (battery replaceable), 1 data collection Hub and decorative Skins. Each bundle is ready to use.",
          index1: 0,
          index2: 0,
          index3: 0,
          list: [
            {
              h2: "2 Pro Tracker Bundle",
              tracker_size_img: "/img/products/bundle_pro_2.png",
              skus: [
                {
                  tracker_skin_img: "/img/products/no_skin.png",
                  opt: [
                    
                    {
                      skuid: "sku_bundle_2_pro_opt_0b",
                      base_price: 74.97,
                      list_price: 69.99,
                      h3: "2 Pro Trackers | No Skin | 1 Travel Hub",
                      image: "/img/products/2_pro_0b.png",
                    },
                  ],
                },
                
              ],
            },
            {
              h2: "3 Pro Tracker Bundle",
              tracker_size_img: "/img/products/bundle_pro_3.png",
              skus: [
                {
                  tracker_skin_img: "/img/products/no_skin.png",
                  opt: [
                    
                    {
                      skuid: "sku_bundle_3_pro_opt_1b",
                      base_price: 104.96,
                      list_price: 89.99,
                      h3: "3 Pro Trackers | No Skin | 1 Travel Hub",
                      image: "/img/products/3_pro_bundle_no_skin.png",
                    },
                  ],
                },
                
              ],
            },
            {
              h2: "4 Pro Tracker Bundle",
              tracker_size_img: "/img/products/bundle_pro_4.png",
              skus: [
                {
                  tracker_skin_img: "/img/products/no_skin.png",
                  opt: [
                    {
                      skuid: "sku_bundle_4_pro_opt_1b",
                      base_price: 134.95,
                      list_price: 109.99,
                      h3: "4 Pro Trackers | No Skin | 1 Travel Hub",
                      image: "/img/products/4_pro_bundle_no_skin.png",
                    },
                  ],
                },
                
              ],
            },

            {
              h2: "5 Pro Tracker Bundle",
              tracker_size_img: "/img/products/bundle_pro_5.png",
              skus: [
                {
                  tracker_skin_img: "/img/products/no_skin.png",
                  opt: [
                    {
                      skuid: "sku_bundle_5_pro_opt_1b",
                      base_price: 164.94,
                      list_price: 129.99,
                      h3: "5 Pro Trackers | No Skin | 1 Travel Hub",
                      image: "/img/products/5_pro_1b.png",
                    },
                  ],
                },
              ],
            },
          ],
        },
      ],
    };
  },
  methods: {
    select_bundle_size(item, index2) {
      item.index1 = index2;
      item.index2 = 0;
      item.index3 = 0;
      this.$refs.carouselkiosk[0].goTo(0)
    },
    select_bundle_design(item, index) {
      item.index2 = index;
    },
    select_bundle_hub(item, index) {
      item.index3 = index;
    },
    getSelectHubClass(item, index) {
      if (item.index3 == index) {
        return "product-select-box2";
      }
      return "product-select-box";
    },
    clicksku_hub(item, index) {
      item.index3 = index;
    },
    getImage(item) {
      return item.list[item.index].image;
    },
    getImage2(item) {
      return item.list[item.index1].skus[item.index2].opt[item.index3].image;
    },
    getImage3(item, index) {
      return item.opt[index].image;
    },
    getPrice(index, mode) {
      var index1 = this.inventory_pro[index].index1;
      var index2 = this.inventory_pro[index].index2;
      var index3 = this.inventory_pro[index].index3;

      if (mode == 0) {
        return this.inventory_pro[index].list[index1].skus[index2].opt[index3]
          .base_price;
      } else if (mode == 1) {
        return this.inventory_pro[index].list[index1].skus[index2].opt[index3]
          .list_price;
      }
    },
    getH3(item, i) {
      //console.log(item.index1 + " " + item.index2 + " " + item.index3);
      var str = item.list[item.index1].skus[item.index2].opt[item.index3].h3;
      var list = str.split("|");
      if (list.length > i) {
        return list[i].trim();
      } else {
        return "";
      }
    },
    getH4(item) {
      var str = item.list[item.index1].skus[item.index2].opt[item.index3].h3;
      if (str.toLowerCase().includes("skin bundle")) {
        return "Designed for both Pro and Classic trackers";
      }
      var list = str.split("|");
      if (list.length > 0) {
        var first = list[0].split(" ")[0];
        return (
          "Ready for " +
          first +
          " users. App free to use. Support all types of toothbrushes, manual or electric."
        );
      } else {
        return "Ready to use. App is free.";
      }
    },
    selectsku(a, b) {
      this.inventory[a].index = b;
    },
    selectsku1(item, index1, index2) {
      item.index1 = index1;
      item.index2 = index2;
    },
    calculateFinalPrice(p) {
      var new_p = p * (1 - store.state.discount_percent);
      return new_p.toFixed(2);
    },

    getCoupon() {
      console.log("get Coupon:" + store.state.couponid);
      return store.state.couponid;
    },
    onAddCart2(item, index1, index2, index3) {
      var sku = {};
      var obj = item.list[index1].skus[index2].opt[index3];
      sku.id = obj.skuid;
      sku.image = obj.image;
      sku.metadata = {};
      sku.metadata.image0 = obj.image;
      sku.productname = item.list[index1].h2;

      sku.attributes = {};
      sku.attributes.Style = obj.h3;
      sku.price = obj.list_price * 100;
      var list = [];
      list.push({ sku: sku, quantity: 1 });
      storage.onAddCart(list, this);
    },
    onAddCart(prod_index) {
      var sku = {};
      var obj =
        this.inventory[prod_index].list[this.inventory[prod_index].index];
      sku.id = obj.skuid;
      sku.image = obj.image;
      sku.metadata = {};
      sku.metadata.image0 = obj.image;
      sku.productname = this.inventory[prod_index].h1;
      if (prod_index == 3 && this.inventory[prod_index].index < 2) {
        sku.productname = this.inventory[prod_index].h1b;
      }
      sku.attributes = {};
      sku.attributes.Style = obj.h3;
      sku.price = obj.list_price * 100;
      var list = [];
      list.push({ sku: sku, quantity: 1 });
      storage.onAddCart(list, this);
    },
    shown() {},
  },
  mounted() {
    var context = this;
    //context.show = true;

    var stripekey = env.stripe_public_key;
    this.$loadScript(
      "https://js.stripe.com/v3/" // production
    ).then(() => {
      //console.log("stripe loaded");
      context.stripe = window.Stripe(stripekey, {
        apiVersion: "2020-08-27",
      });
    });

    this.$loadScript("https://www.paypalobjects.com/api/checkout.js").then(
      () => {}
    );

    storage.clearstorestate();
    //storage.populateSku(this, 1);
    storage.processCoupon();
    storage.saveCart2Store(this);
    storage.processKiosk();
  },
};
</script>

<style lang="scss">

.spec .col-12 {
  text-align: center;
}

.accordion {
  border: 0px solid !important;
}

 .accordion__title {
    padding-left: 0 !important;
    padding-right: 0 !important;
  }
  .h1-font {
    font-size: 28px !important;
    font-weight: 600 !important;
  }
  .h2-font {
    font-size: 24px !important;
  }
  .h3-font {
    font-size: 20px !important;
    font-weight: 600 !important;
  }
  .h4-font {
    font-size: 16px !important;
    text-align: left !important;
    width: 100%;
  }
  .accordion__title-text {
    font-size: 16px !important;
    text-align: left !important;
  }

  .image-side-2-side {
    max-height: 200px !important;
    max-width: 50%;
  }
  .full-width {
    width: 100% !important;
  }
  .accordion__toggle-button {
    text-align: left !important;
  }

.bundle-cell {
  max-width: 20%;
  padding-left: 0;
  padding-right: 10px;
}

.product-select-box {
  border-radius: 5px;
  border: 4px solid;
  border-color: #bdbdbd;
  background-color: white;
}
.product-select-box2 {
  border-radius: 5px;
  border: 4px solid;
  border-color: #fec131;
  background-color: white;
}

.bundle-h1 span,
.bundle-h1 {
  font-size: 30px;
  font-weight: 700;
}

.bundle-h2 span,
.bundle-h2 {
  font-size: 20px;
  font-weight: 700;
}

.modal-backdrop {
  opacity: 0.85 !important;
}
.tile-header {
  border-radius: 10px 10px 0 0;
  color: white;
  text-align: center;
  font-weight: 600;
}

.bundle-container {
  background-color: white;
  border-radius: 0 0 10px 10px;
  margin: 0 auto;
  max-width: 340px;
  padding-bottom: 30px;
}

.bundle-item-container {
  background-color: #f8f8f8;
  border-radius: 10px;
  margin-bottom: 6px;
  cursor: pointer;
  border: 2px solid;
  border-color: #f8f8f8;
  min-height: 55px !important;
}

.bundle-add-cart,
.bundle-add-cart:hover {
  background-color: white;
  color: #12b8ed;
  border-color: #12b8ed;
  padding-left: 20px;
  border: 2px solid;
  padding-right: 20px;
  font-weight: 600;
}

.selected-border {
  border: 3px solid !important;
  border-color: #fec131 !important;
  border-radius: 10px;
}

.unselected-border {
  border: 2px solid;
  border-color: #dfe0e1;
  border-radius: 10px;
}

.bundle-item {
  padding-top: 5px;
  padding-bottom: 5px;
}

@media (max-width: 1199px) {
}
@media (min-width: 1200px) {
  .cart-nav-bundle {
    padding-left: calc(50% - 600px + 45px) !important;
    padding-right: calc(50% - 600px + 45px) !important;
  }
}
@media only screen and (min-width: 1440px) {
  .cart-nav-bundle {
    padding-left: calc(50% - 720px + 45px) !important;
    padding-right: calc(50% - 720px + 45px) !important;
  }
}

.image_bundle {
  padding: 5%;
}

@media (max-width: 768px) {
  .bundle-cell {
    max-width: 25%;
    padding-left: 2px;
    padding-right: 5px;
  }

  .max-width-sm {
    width: 100% !important;
  }
  .reduced_pl_pr {
    padding-left: 0 !important;
    padding-right: 0 !important;
  }
  .pl-pr-0-sm {
    padding-left: 0 !important;
  }
  .bundle-h1 span,
  .bundle-h1 {
    font-size: 26px;
    font-weight: 700;
  }

  .bundle-h2 span,
  .bundle-h2 {
    font-size: 16px;
    font-weight: 700;
  }

  .pl-pr-0-sm {
    padding-left: 0 !important;
    padding-right: 0 !important;
  }
  .image_bundle {
    padding: 0;
  }

  .bundle-item-container {
    max-width: 100%;
  }
}
</style>